import { render, staticRenderFns } from "./justMobSlides.vue?vue&type=template&id=1a12f4a6&scoped=true"
import script from "./justMobSlides.vue?vue&type=script&lang=js"
export * from "./justMobSlides.vue?vue&type=script&lang=js"
import style0 from "./justMobSlides.vue?vue&type=style&index=0&id=1a12f4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12f4a6",
  null
  
)

export default component.exports